import { Formik, Field } from "formik";
import FileUploadForm from "components/PLCTABS/CompanyOfficialsTab/FileUploadForm";
import { getChangedDocumentsModuleData } from "config/changesDocumentData";
import _get from "lodash/get";
import ErrorBanner from "components/lib/Shared/ErrorBanner";

/**
 * SingnedUnsignedDocuments component handles the display, upload, and download of
 * unsigned and signed change documents for company officials.
 *
 * Props:
 * - row: The data row containing the official and document info
 */
const SingnedUnsignedDocuments = ({ row, setFormData, formError }) => {
  return (
    <div className="py-4 mt-2 flex gap-5">
      {/* Unsigned document section */}
      <div className="w-full">
        <div className="px-2">Unsigned version</div>
        <div className="p-3 mt-2 bg-white">
          <Formik
            enableReinitialize
            initialValues={{ fileUploads: { ...row.original.fileUploads } }}
            onSubmit={() => null}
          >
            {(values) => {
              return (
                <div className="pl-4">
                  <Field
                    name="fileUploads"
                    component={FileUploadForm}
                    documentData={getChangedDocumentsModuleData(
                      row.original.fileUploads.consentResolutionType
                        ? "ownConsentResolutionType"
                        : "platformConsentResolutionType"
                    )}
                    resolvedFields={_get(document, "resolvedFields")}
                    onlyPreview
                    showDocumentLabel
                    editorKey={document.fileName}
                    documentName={"approvedChangesDocuments"}
                  />
                </div>
              );
            }}
          </Formik>
        </div>
      </div>
      {/* Signed document upload section */}
      <div className="w-full">
        <div className="px-2">Signed version</div>
        <div className="p-3 mt-2 bg-white">
          <Formik
            enableReinitialize
            initialValues={{ fileUploads: { ...row.original.fileUploads } }}
            onSubmit={() => {}}
          >
            {(values) => {
              setFormData(values.values.fileUploads);
              return (
                <div className="pl-4">
                  <Field
                    name="fileUploads"
                    component={FileUploadForm}
                    documentData={getChangedDocumentsModuleData(
                      "approvedChangesDocuments"
                    )}
                    resolvedFields={_get(document, "resolvedFields")}
                    onlyPreview={false}
                    showDocumentLabel
                    editorKey={document.fileName}
                    documentName={"approvedChangesDocuments"}
                  />
                </div>
              );
            }}
          </Formik>
        </div>
        {formError && <ErrorBanner errors={formError} />}
      </div>
    </div>
  );
};

export default SingnedUnsignedDocuments;
